import { memo, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import { BreadcrumbItem } from 'types/BreadcrumbItem';
import { useRecoilValue } from 'recoil';
import { screenSizeState } from 'recoil/atoms';

interface BreadcrumbsProps {
  breadcrumbs: BreadcrumbItem[];
}

export const Breadcrumbs = memo(function Breadcrumbs({ breadcrumbs }: BreadcrumbsProps) {
  const screenSize = useRecoilValue(screenSizeState);
  const [pl, setPl] = useState('1%');

  useEffect(() => {
    let pl = 'pl-[1%]';
    switch (true) {
      case screenSize <= 3:
        pl = 'pl-[1%]';
        break;
      case screenSize === 4:
        pl = 'pl-[1%]';
        break;
      case screenSize === 5:
        pl = 'pl-[1.3%]';
        break;
      case screenSize === 6:
        pl = 'pl-[2.25%]';
        break;
    }
    setPl(pl);
  }, [screenSize]);

  return (
    <Breadcrumb className={`mt-3 mb-2 ${pl}`}>
      {breadcrumbs.map((item) => (
        <Breadcrumb.Item key={item.label}>
          {item.linkTo ? (
            <Link key={item.linkTo} to={item.linkTo || ''}>
              {item.label}
            </Link>
          ) : (
            item.label
          )}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
});
